import React from 'react';
import styles from './PageHeader.module.css';

// Same 4 posters used in the homepage filmstrip — duplicated to fill the header width
const POSTER_IMGS = [
  '/posters/Dark_Knight_Poster.jpg',
  '/posters/mi-reckoning-web.jpg',
  '/posters/Dolls_of_VooDoo.jpg',
  '/posters/Movie_Posters_1.jpeg',
];

// Repeat enough times to span a wide viewport without visible gaps
const COLLAGE = [
  ...POSTER_IMGS,
  ...POSTER_IMGS,
  ...POSTER_IMGS,
];

export default function PageHeader({ title, subtitle }) {
  return (
    <header className={styles.header} aria-label={title}>
      <div className={styles.collage} aria-hidden="true">
        {COLLAGE.map((src, i) => (
          <div key={i} className={styles.collageCell}>
            <img src={src} alt="" loading="lazy" />
          </div>
        ))}
      </div>
      <div className={styles.overlay} aria-hidden="true" />
      <div className={styles.content}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
    </header>
  );
}
